var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsSidebar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.0711 6.25 10 6.25C7.92893 6.25 6.25 7.92893 6.25 10C6.25 12.0711 7.92893 13.75 10 13.75Z",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4219 6.30469C15.6099 6.57396 15.7746 6.85886 15.9141 7.15625L17.9375 8.28125C18.1902 9.41287 18.1928 10.586 17.9453 11.7187L15.9141 12.8438C15.7746 13.1411 15.6099 13.426 15.4219 13.6953L15.4609 16.0156C14.6034 16.7971 13.5884 17.3858 12.4844 17.7422L10.4922 16.5469C10.1645 16.5703 9.83551 16.5703 9.5078 16.5469L7.52343 17.7344C6.41586 17.3845 5.39757 16.798 4.53905 16.0156L4.57812 13.7031C4.39161 13.4301 4.22703 13.1428 4.08593 12.8438L2.06249 11.7187C1.80983 10.5871 1.80717 9.41401 2.05468 8.28125L4.08593 7.15625C4.22537 6.85886 4.39003 6.57396 4.57812 6.30469L4.53905 3.98438C5.39659 3.20294 6.41154 2.61422 7.51562 2.25781L9.5078 3.45313C9.83551 3.42968 10.1645 3.42968 10.4922 3.45313L12.4766 2.26563C13.5841 2.61554 14.6024 3.20199 15.4609 3.98438L15.4219 6.30469Z",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSidebar);
export default __webpack_public_path__ + "static/media/settings_sidebar.866384cb262ff9748398e6cbb9a14234.svg";
export { ForwardRef as ReactComponent };